import { memberApi } from "./client";

export interface GuideContent { overview: string; how: string }
export interface GuideRevision extends GuideContent { revision: number; saved_at?: string; published_at?: string }
export interface CourseGuide {
  course_id: string; course_status: string; read_at: string;
  can_edit: boolean; can_publish: boolean;
  draft?: GuideRevision | null; published: GuideRevision | null;
}
export interface GuideReceipt { state: "confirmed"; course_id: string; revision?: number; published_revision?: number; waiting_for_course?: boolean }
const route = (course: string) => `/courses/${course}/guide`;
const keyed = (key: string) => ({ headers: { "Idempotency-Key": key } });
export const courseGuideApi = {
  read: (course: string, preparation = false) => memberApi.get<CourseGuide>(`${route(course)}${preparation ? "/preparation" : ""}`),
  save: (course: string, body: GuideContent & { revision: number }, key: string) => memberApi.put<GuideReceipt>(route(course), body, keyed(key)),
  publish: (course: string, body: { revision: number; published_revision: number | null }, key: string) => memberApi.post<GuideReceipt>(`${route(course)}/publish`, body, keyed(key)),
};
